$(".hamburger-wrap").click(function () {
  $(this).toggleClass('active');
  $("#g-nav").toggleClass('panelactive');

  if ($("#g-nav").hasClass('panelactive')) {
    $("body").addClass('no-scroll');
  } else {
    $("body").removeClass('no-scroll');
  }

  if ($("#g-nav").hasClass('panelactive')) {
    $(".p-hamburger__navList").each(function (index) {
      const $this = $(this);
      setTimeout(function () {
        $this.css({
          opacity: 1,
          transform: 'translateX(0)'
        });
      }, index * 150);
    });
  } else {
    $(".p-hamburger__navList").css({
      opacity: 0,
      transform: 'translateX(-100%)'
    });
  }
});

$(".p-hamburger__navListChild").click(function (event) {
  event.stopPropagation(); // 親要素へのイベント伝播を停止
});
